var angular = require('angular');
var AlertAPI = require('../../api/alert');

 angular
  .module("app.directives")
  .directive('notificationCount', function($interval, $rootScope){
    return {
      restrict: 'E',
      scope:true,
      replace:true,
      template: require('./index.pug'),
      link: function(scope, element, attrs){

        $rootScope.notificationCount = 0;
        var refresh = window.conf.notification_refresh || 60;

        // Temporarily disable retrieving the Notification Count until this can be made more efficient.
        // Also need to remove the block on the WAF.
        /*
        $interval(function(){
          $rootScope.reloadNotificationCount();
        }, refresh*1000);

        $rootScope.reloadNotificationCount = function(){
          AlertAPI.GetTotal().then(function(result){
            $rootScope.notificationCount = result.count;
          })
        }

        $rootScope.reloadNotificationCount();
        */
      }
    }
  });
